import React, {useState} from 'react';

import {isEqual} from 'lodash';
import {useDispatch, useSelector} from 'react-redux';

import * as setupActions from '@/actions/setupActions';
import MembraneCutOffSelection from '@/components/selectField/MembraneCutOffSelection';
import SelectField from '@/components/selectField/SelectField';
import * as APPDATA from '@/constants/pcConstAppData';

import './SelectDuration.less';
import './SelectMode.less';
import '../CleaningWizard.less';

const CleainingDurationOption = [
  {value: 2, label: '2'},
  {value: 3, label: '3'},
  {value: 4, label: '4'},
  {value: 5, label: '5'},
  {value: 6, label: '6'},
  {value: 10, label: '10'},
  {value: 15, label: '15'},
];
function SelectDuration() {
  const dispatch = useDispatch();
  const setupStore = useSelector((state) => state.setupStore, isEqual);
  const {cleaningProperties, fontSize} = setupStore;
  const styleCustom = {top: 'auto', bottom: '100%', width: '100%', maxHeight: '300px'};

  const [cleaningDurations, setCleaningDuration] = useState(cleaningProperties.cleaningDuration);

  const [membraneCutOffSizes, setMembraneCutOffSize] = useState(cleaningProperties.membraneCutOffSize);

  const onChangeCleaningDuration = (selected) => {
    const tempCleaningProperties = {...cleaningProperties};
    if (selected.value !== null) {
      tempCleaningProperties.cleaningDuration = selected.value;
    }

    setCleaningDuration(selected.value);
    dispatch(setupActions.setCleaningProperties(tempCleaningProperties));
  };

  const onChangeMembraneCutOff = (selected) => {
    const tempCleaningProperties = {...cleaningProperties};
    if (selected.value !== null) {
      tempCleaningProperties[APPDATA.KEY.MembraneCutOffSize] = selected.value;
    }

    setMembraneCutOffSize(selected.value);
    dispatch(setupActions.setCleaningProperties(tempCleaningProperties));
  };

  return (
    <div className="select-duration">
      {fontSize === APPDATA.LARGE_FONT_SIZE ? '' : <br />}
      {/* <div className="row center top-text"> */}
      <div className="select-mode-wizard">
        <h1>
          Welcome to {APPDATA.MESSAGES.PRODUCT_NAME}
          <sup>
            <b>®</b>
          </sup>{' '}
          Consumables Cleaning Wizard!
        </h1>
        <h2>
          This will clean the entire fluid path of your µPULSE System. <br />
          Please insert two 50 mL tubes loaded with 25 mL of 0.1M NaOH
        </h2>
      </div>
      <div className="select-mode-wizard">
        <div className="row center">
          <div className="col-sm-6 select-membrane-cutoff-size">
            <MembraneCutOffSelection
              value={membraneCutOffSizes}
              onChangeMembraneCutOff={onChangeMembraneCutOff}
            />
          </div>
        </div>
        {fontSize === APPDATA.LARGE_FONT_SIZE ? '' : <br />}
        <div className="row center">
          <div className="col-md-6">
            <div className="select-cleaning-duration">
              <SelectField
                label="Cleaning Duration"
                value={cleaningDurations}
                unit="Minutes"
                options={CleainingDurationOption}
                onChange={onChangeCleaningDuration}
                styleCustom={styleCustom}
              />
            </div>
          </div>
          <br />
        </div>
      </div>
      <br />
    </div>
  );
}

export default SelectDuration;
